__turbopack_context__.v({
  "dropdown": "Menu-module-scss-module__OWzAlG__dropdown",
  "dropdownCategory": "Menu-module-scss-module__OWzAlG__dropdownCategory",
  "dropdownFooter": "Menu-module-scss-module__OWzAlG__dropdownFooter",
  "dropdownLink": "Menu-module-scss-module__OWzAlG__dropdownLink",
  "dropdownSubcategory": "Menu-module-scss-module__OWzAlG__dropdownSubcategory",
  "link": "Menu-module-scss-module__OWzAlG__link",
  "linkWrapper": "Menu-module-scss-module__OWzAlG__linkWrapper",
  "root": "Menu-module-scss-module__OWzAlG__root",
});
